export const SourcetreeLogoBrand = () => (
    <svg
        width="257"
        height="48"
        viewBox="0 0 257 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56.199 39.4219C50.356 39.4219 47.642 38.2719 45.296 37.0759V32.8439C48.103 34.3159 52.427 35.3739 56.429 35.3739C60.984 35.3739 62.686 33.5799 62.686 30.9119C62.686 28.2439 61.03 26.8169 55.279 25.4369C48.47 23.7809 45.434 21.4349 45.434 16.4659C45.434 11.7739 49.022 8.27686 56.061 8.27686C60.432 8.27686 63.238 9.33485 65.308 10.4849V14.6249C62.272 12.8769 59.005 12.3249 55.877 12.3249C51.92 12.3249 49.574 13.7049 49.574 16.4659C49.574 18.9499 51.506 20.1929 56.843 21.5269C63.238 23.1369 66.826 25.2079 66.826 30.6359C66.826 35.8809 63.698 39.4229 56.199 39.4229V39.4219Z"
            fill="#172B4D"
        />
        <path
            d="M70.319 27.415C70.319 20.514 74.367 15.499 81.268 15.499C88.122 15.499 92.125 20.514 92.125 27.415C92.125 34.316 88.123 39.422 81.268 39.422C74.367 39.422 70.319 34.316 70.319 27.415ZM74.183 27.415C74.183 31.786 76.345 35.742 81.268 35.742C86.144 35.742 88.261 31.785 88.261 27.415C88.261 23.045 86.145 19.18 81.268 19.18C76.345 19.18 74.183 23.044 74.183 27.415Z"
            fill="#172B4D"
        />
        <path
            d="M96.2631 15.959H100.22V29.853C100.22 33.993 101.876 35.833 105.649 35.833C109.329 35.833 111.859 33.395 111.859 28.748V15.959H115.816V38.961H111.859V35.189C110.387 37.903 107.672 39.421 104.59 39.421C99.2991 39.421 96.2631 35.787 96.2631 29.438V15.959Z"
            fill="#172B4D"
        />
        <path
            d="M125.658 38.9619H121.793V15.9589H125.658V20.0069C126.992 17.2929 129.292 15.3609 133.801 15.6359V19.4999C128.74 18.9939 125.658 20.5119 125.658 25.3889V38.9609V38.9619Z"
            fill="#172B4D"
        />
        <path
            d="M152.982 38.364C151.602 39.1 149.486 39.422 147.37 39.422C139.181 39.422 135.363 34.454 135.363 27.415C135.363 20.468 139.181 15.499 147.37 15.499C149.44 15.499 151.05 15.775 152.845 16.603V20.283C151.373 19.593 149.808 19.179 147.646 19.179C141.666 19.179 139.227 22.951 139.227 27.414C139.227 31.877 141.711 35.649 147.738 35.649C150.084 35.649 151.556 35.327 152.982 34.821V38.363V38.364Z"
            fill="#172B4D"
        />
        <path
            d="M168.483 39.422C159.88 39.422 156.108 34.454 156.108 27.415C156.108 20.468 159.972 15.499 166.965 15.499C174.05 15.499 176.903 20.422 176.903 27.415V29.209H160.111C160.663 33.119 163.193 35.649 168.622 35.649C171.29 35.649 173.545 35.143 175.615 34.407V38.042C173.729 39.054 170.831 39.422 168.484 39.422H168.483ZM160.064 25.804H172.9C172.67 21.526 170.737 19.088 166.781 19.088C162.594 19.088 160.478 21.802 160.064 25.804Z"
            fill="#172B4D"
        />
        <path
            d="M190.701 35.2351C191.621 35.2351 192.495 35.0511 193.185 34.9131V38.7311C192.495 38.9151 191.713 39.0991 190.517 39.0991C185.594 39.0991 183.202 36.2011 183.202 31.9221V19.6381H179.475V15.9581H183.202V11.0811H187.066V15.9581H193.185V19.6381H187.066V31.8291C187.066 33.8531 188.262 35.2331 190.701 35.2331V35.2351Z"
            fill="#172B4D"
        />
        <path
            d="M202.108 38.9619H198.243V15.9589H202.108V20.0069C203.442 17.2929 205.742 15.3609 210.251 15.6359V19.4999C205.19 18.9939 202.108 20.5119 202.108 25.3889V38.9609V38.9619Z"
            fill="#172B4D"
        />
        <path
            d="M224.188 39.422C215.585 39.422 211.813 34.454 211.813 27.415C211.813 20.468 215.677 15.499 222.67 15.499C229.755 15.499 232.608 20.422 232.608 27.415V29.209H215.816C216.368 33.119 218.898 35.649 224.327 35.649C226.995 35.649 229.25 35.143 231.32 34.407V38.042C229.434 39.054 226.536 39.422 224.189 39.422H224.188ZM215.769 25.804H228.605C228.375 21.526 226.442 19.088 222.486 19.088C218.299 19.088 216.183 21.802 215.769 25.804Z"
            fill="#172B4D"
        />
        <path
            d="M248.292 39.422C239.689 39.422 235.917 34.454 235.917 27.415C235.917 20.468 239.781 15.499 246.774 15.499C253.859 15.499 256.712 20.422 256.712 27.415V29.209H239.92C240.472 33.119 243.002 35.649 248.431 35.649C251.099 35.649 253.354 35.143 255.424 34.407V38.042C253.538 39.054 250.64 39.422 248.293 39.422H248.292ZM239.873 25.804H252.709C252.479 21.526 250.546 19.088 246.59 19.088C242.403 19.088 240.287 21.802 239.873 25.804Z"
            fill="#172B4D"
        />
        <path
            d="M29.729 19.9548C29.729 11.7448 23.074 5.08984 14.864 5.08984C6.65402 5.08984 -0.000976562 11.7448 -0.000976562 19.9548C-0.000976562 26.5608 4.31102 32.1528 10.271 34.0888V41.5378C10.271 42.1248 10.747 42.6018 11.335 42.6018H18.392C18.979 42.6018 19.456 42.1258 19.456 41.5378V34.0938C25.417 32.1588 29.729 26.5618 29.729 19.9558V19.9548ZM14.864 24.9798C12.089 24.9798 9.83902 22.7298 9.83902 19.9548C9.83902 17.1798 12.089 14.9298 14.864 14.9298C17.639 14.9298 19.889 17.1798 19.889 19.9548C19.889 22.7298 17.639 24.9798 14.864 24.9798Z"
            fill="#0082FF"
        />
        <path
            d="M14.865 5.08984V14.9298C17.64 14.9298 19.89 17.1798 19.89 19.9548C19.89 22.7298 17.64 24.9798 14.865 24.9798C17.401 24.9798 19.457 27.0358 19.457 29.5718V34.0928C25.418 32.1578 29.73 26.5608 29.73 19.9548C29.73 11.7448 23.075 5.08984 14.865 5.08984Z"
            fill="url(#paint0_linear_818_469)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_818_469"
                x1="22.297"
                y1="31.4088"
                x2="22.297"
                y2="15.6148"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.176" stopColor="#0050D3" />
                <stop offset="1" stopColor="#0082FF" />
            </linearGradient>
        </defs>
    </svg>
);
